<template>
  <div id="summaryreport">
    <CCard title="Quản lý Báo cáo Thu - Chi" class="mb-2">
      <CCardHeader class="pt-1 pb-1">
        <span class="card-header-title">Quản lý báo cáo Thu - Chi ngân sách</span>
      </CCardHeader>
      <CCardBody class="pt-1 pb-1">
        <CTabs variant="pills" fill :activeTab.sync="tabActiveState">
          <CTab title="Thu ngân sách">
            <CCardBody>
              <search-component ref="revenuesSearchComponent" type="revenues" @searchResponse="displaySearchResult"/>
            </CCardBody>
            <CCard class="mb-2">
              <vue-good-table
                :columns="columnsRevenues"
                :rows="dataRevenues"
                compactMode
                :pagination-options="{
                  enabled: true,
                  perPage: 50,
                  perPageDropdownEnabled: false,
                  nextLabel: 'Trang sau',
                  prevLabel: 'Trang trước',
                  ofLabel: 'của',
                }"
                :search-options="{
                  enabled: false,
                  placeholder: 'Tìm kiếm',
                }"
                :sort-options="{
                  enabled: false,
                }"
                :line-numbers="true"
                :row-style-class="rowStyleClassFn"
              >
                <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
                  Không có dữ liệu
                </div>
                <template slot="table-row" slot-scope="props">
                  <div v-if="props.column.field === 'status'">
                    <CBadge v-if="props.row.status == 0" color="danger">Ngừng sử dụng</CBadge>
                    <CBadge v-else-if="props.row.status == 1" color="success">Đang sử dụng</CBadge>
                    <CBadge v-else-if="props.row.status == 2" color="warning">Đang chờ duyệt</CBadge>
                  </div>
                  <div v-else-if="props.column.field === 'date'">
                    <span>{{props.row.month}}/{{props.row.year}}</span>
                  </div>
                  <div v-else-if="props.column.field === 'action'">
                    <CDropdown
                      color="primary"
                      toggler-text=""
                      style="position: static"
                    >
                      <CDropdownItem
                        @click="showRevenueDetail(props.row.id)"
                        >Chi tiết</CDropdownItem
                      >
                      <CDropdownItem
                        v-if="CheckRole(28) === true && props.row.remote_db_id == null"
                        @click="editRevenues(props.row.id)"
                        >Cập nhật</CDropdownItem
                      >
                      <CDropdownItem
                        v-if="(props.row.status == 1) && CheckRole(30) === true"
                        @click="showStatusRevenues(props.row.id)"
                        >Ngừng sử dụng</CDropdownItem
                      >
                      <CDropdownItem
                        v-if="(props.row.status == 0 || props.row.status == 2) && CheckRole(30) === true"
                        @click="showStatusRevenues(props.row.id)"
                        >Sử dụng</CDropdownItem
                      >
                      <CDropdownItem
                        v-if="CheckRole(29) === true"
                        @click="showDeleteRevenues(props.row.id)"
                        >Xoá</CDropdownItem
                      >
                    </CDropdown>
                  </div>
                  <div v-else-if="props.column.field === 'file'" class="center">
                    <vs-tooltip color="primary">
                      <vs-button
                        transparent
                        @click="displayFileRevenues(props.row.id)"
                        primary
                        circle
                        icon
                        ><i class="bx bxs-file"></i
                      ></vs-button>
                      <template #tooltip>
                        Xem file đính kèm
                      </template>
                    </vs-tooltip>
                  </div>
                </template>
              </vue-good-table>
            </CCard>
          </CTab>
          <CTab title="Chi ngân sách">
            <CCardBody>
              <search-component ref="paySearchComponent" type="pay" @searchResponse="displaySearchResult"/>
            </CCardBody>
            <CCard class="mb-2">
              <vue-good-table
                :columns="columnsPays"
                :rows="dataPays"
                compactMode
                :pagination-options="{
                  enabled: true,
                  perPage: 50,
                  perPageDropdownEnabled: false,
                  nextLabel: 'Trang sau',
                  prevLabel: 'Trang trước',
                  ofLabel: 'của',
                }"
                :search-options="{
                  enabled: false,
                  placeholder: 'Tìm kiếm',
                }"
                :sort-options="{
                  enabled: false,
                }"
                :line-numbers="true"
                :row-style-class="rowStyleClassFn"
              >
                <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
                  Không có dữ liệu
                </div>
                <template slot="table-row" slot-scope="props">
                  <div v-if="props.column.field === 'status'">
                    <CBadge v-if="props.row.status == 0" color="danger">Ngừng sử dụng</CBadge>
                    <CBadge v-else-if="props.row.status == 1" color="success">Đang sử dụng</CBadge>
                    <CBadge v-else-if="props.row.status == 2" color="warning">Đang chờ duyệt</CBadge>
                  </div>
                  <div v-else-if="props.column.field === 'date'">
                    <span>{{props.row.month}}/{{props.row.year}}</span>
                  </div>
                  <div v-else-if="props.column.field === 'action'">
                    <CDropdown
                      color="primary"
                      toggler-text=""
                    >
                      <CDropdownItem
                        @click="showPayDetail(props.row.id)"
                        >Chi tiết</CDropdownItem
                      >
                      <CDropdownItem
                        v-if="CheckRole(28) === true && props.row.remote_db_id == null"
                        @click="EditPays(props.row.id)"
                        >Cập nhật</CDropdownItem
                      >
                      <CDropdownItem
                        v-if="props.row.status == 1 && CheckRole(30) === true"
                        @click="showEditPayStatus(props.row.id)"
                        >Ngừng sử dụng</CDropdownItem
                      >
                      <CDropdownItem
                        v-if="(props.row.status == 0 || props.row.status == 2) && CheckRole(30) === true"
                        @click="showEditPayStatus(props.row.id)"
                        >Sử dụng</CDropdownItem
                      >
                      <CDropdownItem
                        v-if="CheckRole(29) === true"
                        @click="showDeletePays(props.row.id)"
                        >Xoá</CDropdownItem
                      >
                    </CDropdown>
                  </div>
                  <div v-else-if="props.column.field === 'file'" class="center">
                    <vs-tooltip color="primary">
                      <vs-button
                        transparent
                        @click="displayFilePays(props.row.id)"
                        primary
                        circle
                        icon
                        ><i class="bx bxs-file"></i
                      ></vs-button>
                      <template #tooltip>
                        Xem file đính kèm
                      </template>
                    </vs-tooltip>
                  </div>
                </template>
              </vue-good-table>
            </CCard>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>

    <vs-dialog prevent-close width="900px" v-model="activeFiles" scroll overflow-hidden>
      <template #header>
        <h4 class="not-margin">
          Danh sách tệp tin đính kèm
        </h4>
      </template>
      <vue-good-table
        id="file"
        :columns="file_columns"
        :rows="file_data"
        :sort-options="{
          enabled: false,
        }"
      >
        <div slot="emptystate">
          Không có dữ liệu
        </div>
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field === 'action'">
            <vs-tooltip color="warning">
              <CLink :href="props.row.file_url" target="_blank">
                <span><i class="bx bx-download"></i></span>
              </CLink>

              <template #tooltip>
                Xem file đính kèm
              </template>
            </vs-tooltip>
          </div>
        </template>
      </vue-good-table>
    </vs-dialog>

    <vs-dialog prevent-close width="450px" v-model="activeStatusRevenues">
      <template #header>
        <h4 class="not-margin">
          Xác nhận
        </h4>
      </template>
      <span class="center">Bạn có chắc chắn muốn thực hiện thao tác này không?</span>
      <template #footer>
        <div class="con-footer flex flex-end">
          <vs-button danger transparent @click="StatusRevenues(revenues_id)">
            Đồng ý
          </vs-button>
          <vs-button @click="activeStatusRevenues = false" dark transparent>
            Hủy
          </vs-button>
        </div>
      </template>
    </vs-dialog>

    <vs-dialog prevent-close width="450px" v-model="activeDeleteRevenues">
      <template #header>
        <h4 class="not-margin">
          Xác nhận
        </h4>
      </template>
      <span class="center">Bạn có chắc chắn muốn xóa khỏi hệ thống?</span>
      <template #footer>
        <div class="con-footer flex flex-end">
          <vs-button danger transparent @click="DeleteRevenues(revenues_id)">
            Xóa
          </vs-button>
          <vs-button @click="activeDeleteRevenues = false" dark transparent>
            Hủy
          </vs-button>
        </div>
      </template>
    </vs-dialog>

    <vs-dialog prevent-close width="450px" v-model="activeStatusPays">
      <template #header>
        <h4 class="not-margin">
          Xác nhận
        </h4>
      </template>
      <span class="center">Bạn có chắc chắn muốn thực hiện thao tác này không?</span>
      <template #footer>
        <div class="con-footer flex flex-end">
          <vs-button danger transparent @click="EditPayStatus(pays_id)">
            Đồng ý
          </vs-button>
          <vs-button @click="activeStatusPays = false" dark transparent>
            Hủy
          </vs-button>
        </div>
      </template>
    </vs-dialog>
    <vs-dialog prevent-close width="450px" v-model="activeDeletePays">
      <template #header>
        <h4 class="not-margin">
          Xác nhận
        </h4>
      </template>
      <span class="center">Bạn có chắc chắn muốn xóa khỏi hệ thống?</span>
      <template #footer>
        <div class="con-footer flex flex-end">
          <vs-button danger transparent @click="DeletePays(pays_id)">
            Xóa
          </vs-button>
          <vs-button @click="activeDeletePays = false" dark transparent>
            Hủy
          </vs-button>
        </div>
      </template>
    </vs-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters} from "vuex";
import ClientFactory from "@/api/ClientFactory";
import { VueGoodTable } from "vue-good-table";
const dropdownsApi = ClientFactory.get("dropdowns");
const revenuesApi = ClientFactory.get("revenues");
const paysApi = ClientFactory.get("pays");
import SearchComponent from './searchComponent.vue';

export default {
  components: {
    VueGoodTable,
    SearchComponent
  },
  data: () => ({
    //#region  editRevenue
    activeEditRevenues: false,
    valueTypeReport: 1,
    dataTypeReport: [
      {
        label: "Thu ngân sách",
        value: 1,
      },
      {
        label: "Chi ngân sách",
        value: 2,
      },
    ],
    //#endregion

    //#region  searchRevenues
    columnsRevenues: [
      {
        label: "Tên báo cáo",
        field: "report_name",
        thClass: "text-center",
      },
      {
        label: "Thời gian",
        field: "date",
        thClass: "text-center",
        width: "80px",
      },
      {
        label: "Thu nội địa",
        field: "internal_revenue",
        thClass: "text-center",
        tdClass: "text-center",
        // hidden: true,
        width: "80px",
      },
      {
        label: "Thu hoạt động XNK",
        field: "imx_revenue",
        thClass: "text-center",
        tdClass: "text-center",
        // hidden: true,
        width: "80px",
      },
      {
        label: "Thu quản lý qua NS",
        field: "budget_revenue",
        thClass: "text-center",
        tdClass: "text-center",
        width: "80px",
      },
      {
        label: "File",
        thClass: "text-center",
        tdClass: "text-center",
        field: "file",
        width: "50px",
      }
    ],
    dataRevenues: [],
    //#endregion

    //#region  ChangeStatusAndDelete
    activeDeleteRevenues: false,
    revenues_id: 0,
    activeStatusRevenues: false,
    activeFiles: false,
    //#endregion

    //#region  fileRevenues
    file_columns: [
      {
        label: "Loại tệp báo cáo",
        field: "file_type_name",
        thClass: "emu-vgt-thead-th text-center",
        tdClass: "emu-vgt-tbody-td",
      },
      {
        label: "Tên tệp tin",
        field: "file_name",
        thClass: "emu-vgt-thead-th text-center",
        tdClass: "emu-vgt-tbody-td",
      },
      {
        label: "Tải tệp tin",
        field: "action",
        thClass: "emu-vgt-thead-th text-center width-status",
        tdClass: "emu-vgt-tbody-td text-center width-status",
      },
    ],
    file_data: [],
    //#endregion

    //#region searchPay
    columnsPays: [
      {
        label: "Tên báo cáo",
        thClass: "text-center",
        field: "report_name",
      },
      {
        label: "Thời gian",
        field: "date",
        thClass: "text-center",
        width: "80px",
      },
      {
        label: "Chi cân đối NS địa phương",
        field: "localbudget_pay",
        thClass: "text-center",
        tdClass: "text-center",
        // hidden: true,
        width: "80px",
      },
      {
        label: "Chi CT MTQG,DA,nhiệm vụ khác",
        field: "other_pay",
        thClass: "text-center",
        tdClass: "text-center",
        // hidden: true,
        width: "80px",
      },
      {
        label: "File",
        field: "file",
        thClass: "text-center",
        width: "50px",
      },
    ],
    dataPays: [],

    //#endregion

    //#region  EditPays
    activeEditPays: false,
    //#endregion

    //#region  ChangeStatusAndDelete
    activeDeletePays: false,
    pays_id: 0,
    activeStatusPays: false,
    //#endregion

    //#region  DeletePay
    activeDeletePays: false,
    //#endregion
  }),
  async created() {
    if (this.CheckRole(26) === false) {
      this.GoPagesError();
    } else {
      this.dataYearRevenues = await dropdownsApi.get(dropdownsApi.type.YEARS);
      this.dataYearPays = await dropdownsApi.get(dropdownsApi.type.YEARS);
      await this.$refs.revenuesSearchComponent.search();
      await this.$refs.paySearchComponent.search();
    }
  },
  methods: {
    ...mapActions("ui", ["loading", "closeLoading", "notify"]),
    ...mapActions("Budget", ["saveTabState"]),
    displaySearchResult(results) {
      const {type} = results;
      switch(type) {
        case 'revenues':
          this.checkRoleAction(results.data,this.columnsRevenues)
          this.dataRevenues = results.data
          break;
        case 'pay':
          this.checkRoleAction(results.data,this.columnsPays);
          this.dataPays = results.data;
          break;
        default:
          console.log('Unknow type to display search result');
          break
      }
    },
    checkRoleAction(data,columns){
        if(data.length>0){
          if(data[0].check_action > 0){
            let count = 0;
            for (let i = columns.length-1; i > 0; i--) {
              if(columns[i].field === "action"){
                  count++;
              }
            }
            if (count === 0){
              columns.push({
                  label: "Trạng thái",
                  field: "status",
                  thClass: "text-center",
                  tdClass: "text-center",
                  width: "90px",
                },
                {
                  label: "Thao tác",
                  field: "action",
                  thClass: "text-center",
                  tdClass: "text-center",
                  width: "80px",
                },
                )
            }
          }
        }
        return columns;
    },
    //#region  Revenues
    async editRevenues(id) {
      return this.$router.push({ path: `/revenues_pay/editrevenues/${id}` }).catch(() => {});
    },
    showRevenueDetail(id) {
      return this.$router.push({ path: `/revenues_pay/revenuesdetail/${id}` }).catch(() => {});
    },
    showPayDetail(id) {
      return this.$router.push({ path: `/revenues_pay/paydetail/${id}` }).catch(() => {});
    },

    async displayFileRevenues(id) {
      this.loading(this.$vs);
      await this.getdateFileRevenues(id);
      this.activeFiles = true;
      this.closeLoading();
    },
    async getdateFileRevenues(id) {
      let data = [];
      let params = {};
      params.report_id = id;
      params.report_type = 1;
      const result = await revenuesApi.get_revenue_file(params);

      for (let index = 0; index < result.data.length; index++) {
        data[index] = {
          file_type_name: result.data[index].file_type_name,
          file_name: result.data[index].file_name,
          file_url: result.data[index].file_path,
        };
      }
      this.file_data = data;
    },
    async showDeleteRevenues(id) {
      this.revenues_id = id;

      this.activeDeleteRevenues = true;
    },
    async DeleteRevenues(id) {
      console.log(id);

      this.loading(this.$vs);
      let body = {};
      body.report_id = id;
      let result = await revenuesApi.delete_revenue(body);
      console.log(result);
      if (
        typeof result.error !== "undefined" ||
        result.data.status === "failed" ||
        result.status === "failed"
      ) {
        this.closeLoading();
        return this.notify({
          error: true,
          text: result.error || result.message,
        });
      } else {
        this.closeLoading();
        this.$refs.revenuesSearchComponent.search();
        this.activeDeleteRevenues = false;
        return this.notify({
          text: result.data[0].error_message,
        });
      }
    },
    async showStatusRevenues(id) {
      this.revenues_id = id;
      this.activeStatusRevenues = true;
    },
    async StatusRevenues(id) {
      this.loading(this.$vs);

      let body = {};
      body.report_id = id;
      let result = await revenuesApi.update_revenue_status(body);

      if (
        typeof result.error !== "undefined" ||
        result.data.status === "failed" ||
        result.status === "failed"
      ) {
        this.closeLoading();
        return this.notify({
          error: true,
          text: result.error || result.message,
        });
      } else {
        this.closeLoading();
        this.$refs.revenuesSearchComponent.search();
        this.activeStatusRevenues = false;
        return this.notify({
          text: result.data[0].error_message,
        });
      }
    },
    //#endregion

    //#region SearchPays
    NewPaysReport() {
      this.$router.push({ path: `/revenues_pay/addpays` }).catch(() => {});
    },
    //#endregion
    //#region EditPay
    async EditPays(id) {
      return this.$router.push({ path: `/revenues_pay/editpays/${id}` }).catch(() => {});
    },
    //#endregion

    //#region ChangeStatusPay
    async showEditPayStatus(id) {
      this.pays_id = id;
      this.activeStatusPays = true;
    },
    async EditPayStatus(id) {
      console.log(id);
      this.loading(this.$vs);
      let body = {};
      body.report_id = id;
      let result = await paysApi.update_pay_status(body);
      console.log(result);
      if (
        typeof result.error !== "undefined" ||
        result.data.status === "failed" ||
        result.status === "failed"
      ) {
        this.closeLoading();
        return this.notify({
          error: true,
          text: result.error || result.message,
        });
      } else {
        this.closeLoading();
        this.$refs.paySearchComponent.search();
        this.activeStatusPays = false;
        return this.notify({
          text: result.data[0].error_message,
        });
      }
    },

    //#endregion

    //#region DeletePay
    async showDeletePays(id) {
      this.pays_id = id;

      this.activeDeletePays = true;
    },
    async DeletePays(id) {
      console.log(id);

      this.loading(this.$vs);
      let body = {};
      body.report_id = id;
      let result = await paysApi.delete_pay(body);
      console.log(result);
      if (
        typeof result.error !== "undefined" ||
        result.data.status === "failed" ||
        result.status === "failed"
      ) {
        this.closeLoading();
        return this.notify({
          error: true,
          text: result.error || result.message,
        });
      } else {
        this.closeLoading();
        this.$refs.paySearchComponent.search();
        this.activeDeletePays = false;
        return this.notify({
          text: result.data[0].error_message,
        });
      }
    },

    //#endregion

    //#region ShowFilePay
    async getdateFilePays(id) {
      let data = [];
      let params = {};
      params.report_id = id;
      params.report_type = 2;
      const result = await paysApi.get_pay_file(params);

      for (let index = 0; index < result.data.length; index++) {
        data[index] = {
          file_type_name: result.data[index].file_type_name,
          file_name: result.data[index].file_name,
          file_url: result.data[index].file_path,
        };
      }
      this.file_data = data;
    },
    async displayFilePays(id) {
       this.loading(this.$vs);
      this.getdateFilePays(id);
      this.activeFiles = true;
      this.closeLoading();
    },
    //#endregion

    CheckRole(id) {
      return this.AppActiveUser.role.includes(id);
    },
    GoPagesError() {
      this.notify({
        error: true,
        title: "Permission",
        text: "Bạn không có quyền truy cập trang này",
      });
      this.$router
        .push({
          path: "/pages/not-authorized",
        })
        .catch(() => {});
    },
    rowStyleClassFn(row) {
      return (row.remote_db_id != null && row.status == 2) ? 'pending' : 'default';
    },
  },

  computed: {
    ...mapState("auth", ["AppActiveUser"]),
    ...mapState("Budget", ["tabActive"]),
    tabActiveState: {
        get(){
          return this.tabActive;
        },
        set(value){
          return this.saveTabState(value);
        } 
    }
    
  },
};
</script>

<style lang="scss">
#summaryreport {
  .vgt-responsive {
    overflow-x: inherit;
  }
  table.vgt-table td {
    vertical-align: inherit;
    padding: 0em 0.75em 0em 0.75em;
  }
  .width-class {
    min-width: 3px !important;
  }
  .width-status {
    min-width: 10px !important;
  }
  .nav-pills .nav-link {
    background-color: #fff;
    border-radius: 0rem;
    border-bottom: 5px solid #cccccc;
  }
  .nav-pills .nav-link.active{
    color:#082258 ;
    background-color: #fff;
    border-radius: 0rem;
    border-bottom: 5px solid #082258;
  }
  .dropdown button.btn-primary {
    background: white;
    border: 1px solid #082258;
    color: #082258;
  }
  .dropdown-item {
    color: black;
  }
  .dropdown-item.active, .dropdown-item:active {
    background-color: grey;
    color: white;
  }
  .pending {
    background: #fff8d0;
  }
}
</style>
